module.exports = __webpack_public_path__ + "static/media/maf-07.fdf81d9c.png";